import classify from "@feniks-pwa/web-app/web/classify";
import { node, shape, string } from "prop-types";

import __ from "web/Layout/Translations";

import defaultClasses from "./notificationText.scss";

const CheckoutSubscriptionNotificationText = ({
  header,
  description,
  classes,
  descriptionComponent,
}) => (
  <div>
    <strong className={classes.notificationText}>{__(header)}</strong>
    {description && <p className={classes.notificationText}>{description}</p>}
    {descriptionComponent && (
      <p className={classes.notificationText}>{descriptionComponent}</p>
    )}
  </div>
);

CheckoutSubscriptionNotificationText.propTypes = {
  header: string.isRequired,
  description: string,
  classes: shape({}).isRequired,
  descriptionComponent: node,
};

CheckoutSubscriptionNotificationText.defaultProps = {
  descriptionComponent: null,
  description: null,
};

export default classify(defaultClasses)(CheckoutSubscriptionNotificationText);
